import React, { useEffect, useState } from 'react';
import { Container, Row, Col, Alert, Spinner, Badge } from 'react-bootstrap';
import HeaderTwo from '../../components/HeaderTwo';
import { BreadcrumbBox } from '../../components/common/Breadcrumb';
import FooterTwo from '../../components/FooterTwo';
import { Styles } from './styles/instructor.js';
import { INSTRUCTORS_ENDPOINT } from '../../config/api';

const PLACEHOLDER_IMAGE = 'https://via.placeholder.com/400x400?text=Instructor';

const Instructors = () => {
    const [instructors, setInstructors] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');

    useEffect(() => {
        const controller = new AbortController();

        const loadInstructors = async () => {
            setLoading(true);
            setError('');
            try {
                const response = await fetch(`${INSTRUCTORS_ENDPOINT}?limit=100`, { signal: controller.signal });
                if (!response.ok) {
                    const payload = await response.json().catch(() => ({}));
                    throw new Error(payload.message || 'Unable to load instructors.');
                }

                const payload = await response.json();
                const active = Array.isArray(payload.instructors) ? payload.instructors : [];
                setInstructors(active);
            } catch (err) {
                if (err.name !== 'AbortError') {
                    setError(err.message || 'Unable to load instructors.');
                    setInstructors([]);
                }
            } finally {
                if (!controller.signal.aborted) {
                    setLoading(false);
                }
            }
        };

        loadInstructors();

        return () => controller.abort();
    }, []);

    return (
        <Styles>
            <div className="main-wrapper instructor-page">
                <HeaderTwo />
                <BreadcrumbBox title="Instructors" />

                <section className="instructor-area">
                    <Container>
                        {loading && (
                            <div className="text-center my-5">
                                <Spinner animation="border" role="status" />
                            </div>
                        )}
                        {!loading && error && (
                            <Alert variant="danger">{error}</Alert>
                        )}
                        {!loading && !error && instructors.length === 0 && (
                            <Alert variant="info">No instructors available at the moment.</Alert>
                        )}
                        {!loading && !error && instructors.length > 0 && (
                            <Row>
                                {instructors.map((instructor) => {
                                    const expertise = Array.isArray(instructor.expertise) ? instructor.expertise : [];
                                    return (
                                        <Col lg="3" md="4" sm="6" key={instructor._id}>
                                            <div className="instructor-item">
                                                <div className="instructor-image">
                                                    <img
                                                        src={instructor.profileImage || PLACEHOLDER_IMAGE}
                                                        alt={instructor.name}
                                                        className="img-fluid"
                                                    />
                                                </div>
                                                <div className="img-content text-center">
                                                    <h5>{instructor.name}</h5>
                                                    {instructor.title && <p className="title">{instructor.title}</p>}
                                                    {expertise.length > 0 && (
                                                        <div className="expertise">
                                                            {expertise.map((item) => (
                                                                <Badge key={`${instructor._id}-${item}`} variant="success">
                                                                    {item}
                                                                </Badge>
                                                            ))}
                                                        </div>
                                                    )}
                                                    <ul className="list-unstyled contact">
                                                        {instructor.email && (
                                                            <li><i className="las la-envelope"></i>{instructor.email}</li>
                                                        )}
                                                        {instructor.phone && (
                                                            <li><i className="las la-phone"></i>{instructor.phone}</li>
                                                        )}
                                                    </ul>
                                                </div>
                                            </div>
                                        </Col>
                                    );
                                })}
                            </Row>
                        )}
                    </Container>
                </section>

                <FooterTwo />
            </div>
        </Styles>
    );
};

export default Instructors;
